import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Trash2, Eye } from "lucide-react";
import { toast } from "sonner";

export default function AdminQuotes() {
  const [quotes, setQuotes] = useState([]);
  const [sel, setSel] = useState(null);

  const load = () => api.get("/admin/quotes").then((r) => setQuotes(r.data));
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    await api.delete(`/admin/quotes/${id}`);
    toast.success("Silindi"); load();
  };

  const setStatus = async (id, status) => {
    await api.put(`/admin/quotes/${id}`, { status });
    toast.success("Güncellendi"); load();
  };

  return (
    <div className="p-8 max-w-7xl" data-testid="admin-quotes">
      <h1 className="heading-serif text-3xl font-semibold text-navy mb-6">Teklifler ({quotes.length})</h1>
      <div className="bg-white rounded-xl overflow-hidden border border-gray-100">
        <table className="w-full text-sm">
          <thead className="bg-softbg text-xs uppercase tracking-wider text-gray-500">
            <tr>
              <th className="text-left p-3">Tarih</th>
              <th className="text-left p-3">Kişi</th>
              <th className="text-left p-3">Firma</th>
              <th className="text-left p-3">Kaynak</th>
              <th className="text-center p-3">Ürün</th>
              <th className="text-center p-3">Durum</th>
              <th className="text-right p-3">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {quotes.map((q) => (
              <tr key={q.id} className="border-t border-gray-100 hover:bg-softbg/50">
                <td className="p-3 text-xs">{q.created_at?.slice(0, 10)}</td>
                <td className="p-3">
                  <div className="font-medium text-navy">{q.contact_name}</div>
                  <div className="text-[11px] text-gray-500">{q.contact_email}</div>
                </td>
                <td className="p-3 text-gray-600">{q.company || "-"}</td>
                <td className="p-3"><span className="text-xs bg-softbg rounded-full px-2 py-0.5">{q.source || "-"}</span></td>
                <td className="p-3 text-center">{(q.items || []).length}</td>
                <td className="p-3 text-center">
                  <select className="text-xs border rounded px-2 py-1 bg-softbg" value={q.status || "new"} onChange={(e) => setStatus(q.id, e.target.value)} data-testid={`quote-status-${q.id}`}>
                    <option value="new">Yeni</option>
                    <option value="in_progress">İşlemde</option>
                    <option value="replied">Yanıtlandı</option>
                    <option value="closed">Kapandı</option>
                  </select>
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => setSel(q)} className="p-1.5 text-gray-500 hover:text-teal"><Eye size={14} /></button>
                  <button onClick={() => del(q.id)} className="p-1.5 text-gray-500 hover:text-rose-600"><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={!!sel} onOpenChange={(v) => !v && setSel(null)}>
        <DialogContent className="max-w-2xl">
          <DialogHeader><DialogTitle className="heading-serif">Teklif Detayı</DialogTitle></DialogHeader>
          {sel && (
            <div className="text-sm space-y-3">
              <div className="grid grid-cols-2 gap-3">
                <KV k="Ad" v={sel.contact_name} />
                <KV k="Firma" v={sel.company} />
                <KV k="E-posta" v={sel.contact_email} />
                <KV k="Telefon" v={sel.contact_phone} />
                <KV k="Tesis" v={sel.facility_type} />
                <KV k="Yıldız" v={sel.star_target} />
                <KV k="Oda" v={sel.room_count} />
                <KV k="Kaynak" v={sel.source} />
              </div>
              {sel.notes && <div className="bg-softbg rounded p-3 text-xs">{sel.notes}</div>}
              {sel.items?.length > 0 && (
                <div>
                  <div className="font-medium text-navy mb-1">Ürünler ({sel.items.length})</div>
                  <ul className="text-xs space-y-1 max-h-64 overflow-y-auto admin-scroll">
                    {sel.items.map((it, i) => (
                      <li key={i} className="flex justify-between p-2 bg-softbg rounded">
                        <span>{it.name}</span>
                        <span>× {it.quantity}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className="flex gap-2 pt-2">
                <a href={`mailto:${sel.contact_email}`} className="btn-gold !py-2 !px-4 text-xs">E-posta ile Yanıtla</a>
                <Button variant="outline" onClick={() => setSel(null)}>Kapat</Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

const KV = ({ k, v }) => (
  <div>
    <div className="text-xs text-gray-500">{k}</div>
    <div className="font-medium text-navy">{v || "-"}</div>
  </div>
);
